module.exports = __webpack_public_path__ + "img/1P.267e9767.jpg";